import { MongoObservable } from 'meteor-rxjs';
import { Speciality } from '../models/speciality';

export const Specialities = new MongoObservable.Collection<Speciality>(
  'specialities',
);
